import type { ResumeData } from "@/schema/resume/data";

import { generateRandomName } from "@/utils/string";

const MAX_RESUME_NAME_LENGTH = 64;

function normalizeResumeName(value: string | undefined): string | null {
  const normalized = value?.trim().replace(/\s+/g, " ");
  if (!normalized) return null;

  return normalized.slice(0, MAX_RESUME_NAME_LENGTH);
}

function stripFileExtension(filename: string | undefined): string | undefined {
  const basename = filename?.split(/[/\\]/).pop();
  if (!basename) return undefined;

  return basename.replace(/\.[^/.]+$/, "");
}

export function deriveImportedResumeName({
  data,
  sourceFilename,
  fallbackName = generateRandomName(),
}: {
  data: ResumeData;
  sourceFilename?: string;
  fallbackName?: string;
}) {
  return (
    normalizeResumeName(data.basics.name) ?? normalizeResumeName(stripFileExtension(sourceFilename)) ?? fallbackName
  );
}
